import React from "react";
import { questionsAndAnswers } from "../../configs/questions-answers";
import Accordion from "./Accordion";

const QuestionsAndAnswers = () => {
  return (
    <div className="mt-20 mb-40">
      <div className="flex gap-12">
        <div className="flex flex-col w-1/2 gap-9">
          <div className="text-lg font-semibold">Questions & Answers</div>
          <div className="text-5xl font-extrabold">Have Questions?</div>
          <div className="font-semibold leading-loose">
            At EasyDuct, we are committed to providing you with a seamless and
            valuable upgrade experience. With our pro version priced at only 8
            cents per day, imagine how much you can save by avoiding just one
            error per year, or even one error per month. EasyDuct is the
            affordable and high-value solution for all your ductwork ordering.
          </div>
        </div>
        <div className="flex flex-col w-1/2">
          {questionsAndAnswers.map((question, index) => (
            <div key={index}>
              <Accordion props={question} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionsAndAnswers;
